import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createSquadBannerAPI } from "./squadBannersAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  createStatus: "idle",
  error: null,
  /** Field-level errors for form inputs: { key, name, nameAr, availableFor, unlockType, header, background, ... } */
  fieldErrors: {},
};

export const createSquadBanner = createAsyncThunk(
  "squadBanners/create",
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const data = await createSquadBannerAPI(formData);
      dispatch(
        showModal({
          message: "تم إنشاء البانر بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (err) {
      const message =
        err.response?.data?.error || err.response?.data?.message || "فشل في إنشاء البانر";
      const fieldErrors = err.response?.data?.fieldErrors || {};
      dispatch(showModal({ message, status: "error" }));
      return rejectWithValue({ message, fieldErrors });
    }
  }
);

const squadBannersSlice = createSlice({
  name: "squadBanners",
  initialState,
  reducers: {
    clearFieldErrors: (state) => {
      state.fieldErrors = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSquadBanner.pending, (state) => {
        state.createStatus = "loading";
        state.error = null;
        state.fieldErrors = {};
      })
      .addCase(createSquadBanner.fulfilled, (state) => {
        state.createStatus = "succeeded";
        state.error = null;
        state.fieldErrors = {};
      })
      .addCase(createSquadBanner.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.payload?.message || "فشل في إنشاء البانر";
        state.fieldErrors = action.payload?.fieldErrors || {};
      });
  },
});

export const { clearFieldErrors } = squadBannersSlice.actions;
export default squadBannersSlice.reducer;
